import { ApiResponseError } from "./use-api";

export const formatApiError = (error: unknown, fallback: string): string => {
  if (error instanceof ApiResponseError && error.body && typeof error.body === "object") {
    const body = error.body as { errors?: { errors?: Record<string, string> }[]; message?: string | string[] };
    const fieldMessages = body.errors?.flatMap((entry) => Object.values(entry.errors ?? {})) ?? [];
    if (fieldMessages.length) return fieldMessages.join(". ");
    if (Array.isArray(body.message)) return body.message.join(". ");
    if (body.message) return body.message;
  }
  return fallback;
};
